/** Start the portal. */
import { createElement, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import './i18n'
import { initializeAuthentication } from './auth'
import { PortalRoot } from './components/PortalRoot.tsx'
import { HealRoot } from './heal/HealRoot.tsx'
import { installHealErrorCapture } from './heal/errorCapture.ts'
import { isHealRoute } from './heal/route.ts'

const root = createRoot(document.getElementById('root')!)

async function startPortal() {
  try {
    await initializeAuthentication()
    installHealErrorCapture()
    const Root = isHealRoute(window.location.pathname) ? HealRoot : PortalRoot
    root.render(createElement(StrictMode, null, createElement(Root)))
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Authentication failed'
    root.render(createElement('main', { className: 'startup-error' },
      createElement('h1', null, 'Sign-in unavailable'),
      createElement('p', null, message),
    ))
  }
}

void startPortal()
